import React from 'react';

const PriorMarriages = ({ nextStep, prevStep }) => {
  return (
    <div className="question-screen">
      <button onClick={prevStep} className="btn btn-secondary question-back-button">
        Back to Previous Question
      </button>
      
      <h1 className="question-title">PRIOR MARRIAGES</h1>
      <p className="question-subtitle">Reference: <a href="https://legis.la.gov/legis/Law.aspx?d=106999" target="_blank" rel="noopener noreferrer">La. R.S. 9:224</a></p>
      
      <div className="question-content">
        <p>
          If either applicant's last marriage ended due to death of spouse or divorce, you will need to know the exact date of 
          the death or divorce. Please refer to your Judgment of Divorce or Certificate of Death for this information as accuracy 
          is important for Social Security Administration purposes. You will need to indicate only how the most recent marriage 
          ended; this information is not needed for prior marriages. If you have a Judgment of Divorce or Death Certificate (or 
          photocopy thereof) for your most recent marriage, please bring it with you when you obtain the marriage license. The 
          Clerk of Court will retain photocopies of the documents; the originals will be returned to you at the time the license 
          is issued.
        </p>
      </div>
      
      <div className="question-actions">
        <button onClick={nextStep} className="btn btn-primary">
          Continue Application
        </button>
      </div>
    </div>
  );
};

export default PriorMarriages;
